<template>
    <div>
        <app-header title="">
            <template v-slot:actions>
                <button type="button" class="btn btn-primary mt-2 mt-xl-0" v-c-modal:createDrawer="{}">
                    <i class="far fa-plus"></i> Project
                </button>
            </template>
        </app-header>

        <div class="container my-5">
            <h2>Projects</h2>

            <projects-list-filters v-model="params" />

            <c-data-list ref="dataList" class="list-cards list-projects" :items="projects" @load="loadNextPage">
                <template v-slot:columns>
                    <div class="col-12 col-lg-5">
                        <p>Project / Stage</p>
                    </div>
                    <div class="col-6 col-lg-3">
                        <p>Dates</p>
                    </div>
                    <div class="col-6 col-lg-2">
                        <p>Team</p>
                    </div>
                    <div class="col-12 col-lg-2 text-end">
                        <p>Status</p>
                    </div>
                </template>
                <template v-slot:default="slotProps">
                    <projects-list-item :project="slotProps.item" />
                </template>
                <template v-slot:empty>
                    No projects to show.
                </template>
            </c-data-list>
        </div>

        <create-drawer ref="createDrawer" :prop-project="newProject" mode="create" />
    </div>
</template>

<script>

    import { notify } from 'utils'
    import stage from './stage.vue'
    import CreateDrawer from './CreateDrawer'
    import Datepicker from 'vuejs-datepicker'
    import Multiselect from 'vue-multiselect'
    import { isEqual, debounce } from 'lodash'
    import Project from '@/models/project.js'
    import ProjectsListItem from './ProjectsListItem'
    import ProjectsListFilters from './ProjectsListFilters'
    import { Selectize, LaddaButton } from 'components/form/input'
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

    export default {

        components: {
            stage,
            Selectize,
            Datepicker,
            LaddaButton,
            Multiselect,
            ProjectsListItem,
            ProjectsListFilters,
            CreateDrawer
        },

        data: function () {
            return {
                // projects: [],
                newProject: new Project(),
                selectedUser: null,
                selectedClient: null,
                selectedType: null,
                current_page: 1,
                last_page: 1,
                totalProjects: 0,
                loading: true,
                typeFilter: null,
                searching: false,
                params: {},
                types: [
                	{id: 1, text:'Project'},
                	{id: 2, text:'Backlog'},
                ],
                stage1: 1,
                stage2: 1,
                stage3: 1,
                projectId: null,
                selectedStage: {},
                stages: [
                    {id: 1, name:"Business Review"},
                    {id: 2, name:"Design and Requirements"},
                    {id: 3, name:"Development"}

                ]
            }
        },
        mounted: function() {
            this.getProjects(this.params)

            this.$watch('params', async (params, oldParams) => {
                if (isEqual(params, oldParams)) {
                    return
                }

                await this.getProjects(params)
            })
        },
        created: function() {
            this.$store.users = []
        	//Filter project type based on passed query var
        	if (this.$route.query.type) {
        		this.typeFilter = this.$route.query.type
            }

            this.getUsers()
            this.getClients()
            this.getStatuses()

        	//this.fetchData();
        },
        watch: {
            stage1(newVal) {
                if (newVal) {
                    this.newProject.stages.push(1)
                    return
                }

                this.newProject.stages.splice(this.newProject.stages.indexOf(1), 1);
            },
            stage2(newVal) {
                if (newVal) {
                    this.newProject.stages.push(2)
                    return
                }

                this.newProject.stages.splice(this.newProject.stages.indexOf(2), 1);
            },
            stage3(newVal) {
                if (newVal) {
                    this.newProject.stages.push(3)
                    return
                }

                this.newProject.stages.splice(this.newProject.stages.indexOf(3), 1);
            },

            //Watch route to detect when query value changes
            '$route': function(newRoute, oldRoute) {
    			if (this.$route.query.type) {
        			this.typeFilter = this.$route.query.type
        		} else {
        			this.typeFilter = null
        		}

        		//this.fetchData();
            },

        },

        computed: {
            ...mapState('users', ['users']),
            ...mapState('clientsList', ['clients']),
            ...mapState('yodizproject', {projects: 'list'}),

            haveProjects () {
                return this.projects.length > 0
            },
        },

        methods: {
            ...mapActions('users', ['getUsers']),
            ...mapActions('status', ['getStatuses']),
            ...mapActions('clientsList', ['getClients']),
            ...mapActions('yodizproject', {
                getProjects: 'getList',
                getProjectsForNextPage: 'getListForNextPage',
                addProject: 'addListObject'
            }),

            handleSelectedClient(client) {
                this.selectedClient = client

                if (client) {
                    this.newProject.client_id = client.id
                }
            },

            handleSelectedUser(user) {
                this.selectedUser = user

                if (user) {
                    this.newProject.project_owner_id = user.id
                }
            },

            handleSelectedType(type) {
                this.selectedType = type

                if (type) {
                    this.newProject.project_type_id = type.id
                }
            },

            async loadNextPage(done) {
                try {
                    await this.getProjectsForNextPage(this.params)

                    done()
                } catch (error) {
                    done(true)
                }
            },

            focusProject: function(id) {
                this.projectId = id;

            },
            addStage: function() {
                if (this.projectId && this.selectedStage.id) {

                    var that = this
                    var projectId = this.projectId;

                    return client({path: '/projects/'+projectId+'/stages', entity: {'projectId': projectId, 'stageId':this.selectedStage.id}, method: 'POST'}).then(
                        function(response) {
                            //add the new stage to the project list
                            that.projects.find(x => x.id === projectId).stages.push(response.entity)
                        },
                        function(response) {

                            if (response.status.code == 422) {
                                var firstValidationIssue = response.entity[Object.keys(response.entity)[0]];

                            }
                        }
                    )
                    this.selectedStage = {}
                    this.projectId = null
                }

            },

            selectedStartDate: function(e) {

                this.newProject.start_date = e
            },

            selectedEndDate: function(e) {

                this.newProject.end_date = e
            }
        }
    }
</script>
